module.exports = __webpack_public_path__ + "static/img/headlogo.a7edd64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/headlogo.jpg
// module id = eYx7
// module chunks = 1